
import * as angular from 'angular';

import { TiposDocumentosRequeridosService } from './tiposdocumentosrequeridos.service';

export const TiposDocumentosRequeridosModule = angular.module('TiposDocumentosRequeridosModule', ['ui.router.state'])
    .service('TiposDocumentosRequeridosService', TiposDocumentosRequeridosService)
    .name;
